import React, { useState, useEffect } from "react";
import MaterialTable from "material-table";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import { ToastContainer, toast } from "react-toastify";
import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import { getTrans as t } from "../../../Localization/translations";

import AddTermCondition from "./add-termcondition";
import EditTermCondition from "./edit-termcondition";

function TermConditionContractView({ contract_id }) {
    const [items, setItems] = useState([]);
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [termId, setTermId] = useState("");

    // ✅ FETCH TERMS
    const fetchTerms = () => {
        if (!contract_id) return;

        axios
            .get(`${API}contracts/terms/?contract_id=${contract_id}`, {
                headers: authHeader(),
            })
            .then((res) => {
                if (res.data.success === 1) {
                    setItems(res.data.response);
                }
            })
            .catch(() => toast.error("Failed to load terms"));
    };

    useEffect(() => {
        fetchTerms();
    }, [contract_id]);

    // ✅ DELETE
    const handleDelete = (id) => {
        confirmAlert({
            message: "Are you sure you want to delete this Term?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => {
                        axios
                            .delete(`${API}contracts/terms/${id}/delete/`, {
                                headers: authHeader(),
                            })
                            .then((res) => {
                                if (res.data.success) {
                                    toast.success("Term Deleted Successfully");
                                    fetchTerms();
                                }
                            });
                    },
                },
                { label: "No" },
            ],
        });
    };

    // ✅ MATCH PARTY ROLE NAVIGATION
    if (showAdd)
        return (
            <AddTermCondition
                contract_id={contract_id}
                onClose={() => setShowAdd(false)}
                refresh={fetchTerms}
            />
        );

    if (showEdit)
        return (
            <EditTermCondition
                id={termId}
                onClose={() => setShowEdit(false)}
                refresh={fetchTerms}
            />
        );

    return (
        <>
            <ToastContainer />

            <div className="row py-2">
                <div className="col-md-12">
                    <div className="mb-0">
                        {/* ✅ HEADER SAME AS PARTY ROLE */}
                        <div className="header pb-0">
                            <div className="d-lg-flex">
                                <div>
                                    <h5 className="mb-0">{t("Terms & Conditions")}</h5>
                                </div>

                                <div className="ms-auto my-auto mt-lg-0 mt-4">
                                    <button
                                        className="btn btn-primary mb-0"
                                        onClick={() => setShowAdd(true)}
                                    >
                                        +&nbsp; {t("New Term")}
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* ✅ BODY WRAPPER (IMPORTANT) */}
                        <div className="body">
                            <div className="p-0">

                                <MaterialTable
                                    style={{
                                        padding: "0.5rem 0.5rem",
                                        backgroundColor: "var(--bs-table-bg)",
                                        borderBottomWidth: "1px",
                                        boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                                    }}
                                    columns={[
                                        {
                                            title: `${t("Name")}`,
                                            field: "name",
                                            headerStyle: {
                                                verticalAlign: "inherit",
                                                fontWeight: "bold",
                                                textAlign: "left",
                                            },
                                            cellStyle: {
                                                textAlign: "left",
                                                fontSize: 12,
                                            },
                                            render: (rowData) => (
                                                <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {t("Name")}
                                                    </div>
                                                    <div>{rowData.name || "None"}</div>
                                                </>
                                            ),
                                        },
                                        {
                                            title: `${t("Value")}`,
                                            field: "value",
                                            headerStyle: {
                                                verticalAlign: "inherit",
                                                fontWeight: "bold",
                                                textAlign: "left",
                                            },
                                            cellStyle: {
                                                textAlign: "left",
                                                fontSize: 12,
                                            },
                                            render: (rowData) => (
                                                <>
                                                    <div className="d-xl-none tc d-md-none d-lg-none">
                                                        {t("Value")}
                                                    </div>
                                                    <div>{rowData.value || "None"}</div>
                                                </>
                                            ),
                                        },
                                    ]}
                                    data={items}
                                    actions={[
                                        {
                                            icon: () => (
                                                <img
                                                    src={process.env.PUBLIC_URL + '/static/images/ic-edit.svg'}
                                                    alt="Edit"
                                                />
                                            ),
                                            tooltip: "Edit",
                                            onClick: (e, row) => {
                                                setTermId(row.id);
                                                setShowEdit(true);
                                            },
                                        },
                                        {
                                            icon: () => (
                                                <img
                                                    src={process.env.PUBLIC_URL + '/static/images/ic-delete.svg'}
                                                    alt="Delete"
                                                />
                                            ),
                                            tooltip: "Delete",
                                            onClick: (e, row) => handleDelete(row.id),
                                        },
                                    ]}
                                    options={{
                                        headerStyle: {
                                            backgroundColor: "white",
                                            color: "#245C7F",
                                            fontSize: 12,
                                        },
                                        rowStyle: (rowData, index) => {
                                            if (index % 2) {
                                                return { backgroundColor: "#fff" };
                                            }
                                        },
                                        sorting: true,
                                        search: false,
                                        toolbar: false,
                                        paging: true,
                                        pageSize: 3,
                                        emptyRowsWhenPaging: false,
                                        pageSizeOptions: [3, 15, 20, 50],
                                        paginationType: "stepped",
                                        showFirstLastPageButtons: false,
                                        actionsColumnIndex: -1,
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TermConditionContractView;